exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-input--selection-controls[data-v-157cd714]{margin-top:0!important}.v-input--selection-controls .v-input__slot>.v-label[data-v-157cd714],.v-input--selection-controls .v-radio>.v-label[data-v-157cd714]{font-size:12px!important}", ""]);

// exports
